import actionType from '../actions/actionTypes';
import { TrainedModelSummary } from '@nexxt/common/types';

export interface IConversationalReducer {
    trainedModelSummaries: TrainedModelSummary[];
}

const initialState: IConversationalReducer = {
    trainedModelSummaries: []
};

/** Reducer for state data related to conversational service. */
export default function (state: IConversationalReducer = initialState, action) {
    switch (action.type) {
        case actionType.GET_TRAINED_MODEL_SUMMARIES:
            return {
                ...state,
                trainedModelSummaries: action.payload as TrainedModelSummary[]
            };
        default:
            return state;
    }
}
